<template>
  <v-layout justify-space-between class="pt-2" style="border-bottom: 1px solid #eee;">
    <v-flex shrink>
      <v-btn
        color="transparent"
        fab
        small
        elevation="0"
        class="ml-2"
        @click="setSelectedPageId(null)"
      >
        <c-icon icon="context" color="blue darken-1" size="22"></c-icon>
      </v-btn>
    </v-flex>
    <v-flex class="mb-0 grey--text text--darken-3 shrink" style="min-width: 100px;">
      <context-header-title :useCanEdit="userCanEdit"></context-header-title>
    </v-flex>
    <v-col class="shrink pt-1 pb-0">
      <v-btn
        icon
        :color="contextFavorite ? 'primary' : 'grey'"
        @click="contextFavorite = contextFavorite ? false : 'favorite'"
      >
        <v-icon v-if="contextFavorite">star</v-icon>
        <v-icon v-else>star_border</v-icon>
      </v-btn>
    </v-col>
    <v-spacer></v-spacer>
    <v-flex shrink pa-2 py-1 v-if="userCanEdit">
      <!-- <v-dialog v-if="context" v-model="stateTimeline" max-width="800">
        <template v-slot:activator="{ on }">
          <v-btn text color="primary" v-on="on">
            <template v-if="$vuetify.breakpoint.mdAndDown">
              STATE
            </template>
            <template v-else>
              <span class="grey--text pr-1">State: </span>
              {{
                context.states && context.states.length
                  ? context.states[0].state
                  : 'Just created context' | truncate(20)
              }}
            </template>
          </v-btn>
        </template>
        <state-timeline v-if="stateTimeline" @close="stateTimeline = false"></state-timeline>
      </v-dialog> -->
      <!-- <v-flex shrink pa-2 py-1 v-if="userCanEdit || $vuetify.breakpoint.xsOnly"> -->
      <v-btn
        v-if="$vuetify.breakpoint.smAndUp"
        text
        @click="setModal({ item: context, type: 'contextPermissions', show: true })"
        >Share</v-btn
      >
    </v-flex>
    <!-- <v-flex shrink pa-2 py-1 v-if="userCanEdit">
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn text color="primary" v-on="on">
            <span v-if="$vuetify.breakpoint.lgAndUp" class="grey--text pr-1">My Status: </span>
            {{ contextStatus }}
            <v-icon>arrow_drop_down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(item, index) in ['current', 'later', 'completed']"
            :key="index"
            @click="contextStatus = item"
          >
            <v-list-item-title>{{ item.toUpperCase() }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-flex> -->
  </v-layout>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';

import ContextHeaderTitle from './ContextHeaderTitle';
import StateTimeline from '../StateTimeline';
export default {
  name: 'ContextHeader',
  components: { ContextHeaderTitle, StateTimeline },
  data() {
    return {
      stateTimeline: false
    };
  },
  computed: {
    ...mapGetters('context', ['context', 'userCanEdit']),
    ...mapGetters('userWorkspaceLite', ['currentUserWorkspaceLite']),
    contextFavorite: {
      get() {
        let status = false;
        if (this.currentUserWorkspaceLite && this.currentUserWorkspaceLite.documentData) {
          const userContext = this.currentUserWorkspaceLite.documentData[this.context.id];
          status = userContext ? userContext.userStatus : false;
        }
        return !!status;
      },
      set(v) {
        console.log(v);
        this.updateContextUserStatus({
          status: v,
          userWorkspaceLiteId: this.currentUserWorkspaceLite.id,
          contextId: this.context.id
        });
      }
    }
  },
  methods: {
    ...mapMutations('components/settingsModal', ['setModal']),
    ...mapMutations('views/context', ['setShowResourcePanel', 'setSelectedPageId']),
    ...mapActions('userWorkspaceLite', ['updateContextUserStatus']),
    ...mapActions('context', ['updateContextData'])
  }
};
</script>

<style></style>
